var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"visible":_vm.visible,"title":"移动"},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('a-form',{attrs:{"form":_vm.form}},[_c('a-form-item',{attrs:{"label":"移至"}},[_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'newChannelId',
          {
            rules: [{ required: true, message: '选择频道', trigger: 'blur' }],
          },
        ]),expression:"[\n          'newChannelId',\n          {\n            rules: [{ required: true, message: '选择频道', trigger: 'blur' }],\n          },\n        ]"}]},_vm._l((_vm.channelList),function(item){return _c('a-select-option',{key:item.id,attrs:{"value":item.id}},[_vm._v(_vm._s(item.name))])}),1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }